import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { InventoryStaffStockInfoComponent } from '@inventory/components/waste-disposal';
import { SignaturePadModule } from 'ngx-signaturepad';
import { WasteDisposalRoutingModule, wasteDisposalDeclarationComponents} from './waste-disposal-routing.module';

@NgModule({
  declarations: [
    ...wasteDisposalDeclarationComponents
  ],
  imports: [
    CommonModule, MaterialModule, SharedModule, LayoutModule,WasteDisposalRoutingModule,
    SignaturePadModule,
  ],
  entryComponents: [InventoryStaffStockInfoComponent]
})
export class WasteDisposalModule { }
